import { useRef } from "react";

import {
    Button,
    Form,
    Modal,
    Space,
    Icons,
    notificationProvider,
    useModalForm,
} from "@pankod/refine-antd";
import NestsxCrud from "dataProvider/nestjs-crud";
import { API_URL } from "App";

export const AgenticUploadXlsxModal: React.FC<{label: string}> = ({ label }) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const API_PATH = '/invoice-ap-processing/internal-portal/bulk-xlsx-upload';

    const handleIconClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;
        if (file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type !== 'application/vnd.ms-excel') {
            notificationProvider.open({ message: 'Please upload an XLSX file.', type: 'error', description: '' });
            return;
        }
        try {
            const token = sessionStorage.getItem("konsole-token");
            const formData = new FormData();
            formData.append('file', file);

            const response = await fetch(`${API_URL}${API_PATH}`, {
                method: 'post',
                headers: { authorization: token ? `Bearer ${token}` : "" },
                body: formData,
            });

            if (!response.ok) {
                notificationProvider.open({ message: 'Upload failed', type: 'error', description: '' });
                return;
            }

            notificationProvider.open({ message: `Successfully uploaded for '${label}'`, type: 'success', description: 'Upload complete' });
        } catch (err: any) {
            notificationProvider.open({ message: err?.message || 'Upload failed', type: 'error', description: '' });
        }
        if (fileInputRef.current) fileInputRef.current.value = '';
    };

    let {
        modalProps: AgenticXlsxUploadModal,
        formProps: AgenticXlsxUploadForm,
        show: AgenticXlsxUploadShow,
        close: AgenticXlsxUploadClose
    } = useModalForm({
        resource: API_PATH,
        dataProviderName: "grapghQl",
        action: "create",
        metaData: { },
        redirect: false,
        onMutationSuccess() {
            AgenticXlsxUploadClose();
        }
    });
    AgenticXlsxUploadModal.title = label;
    AgenticXlsxUploadModal.centered = true;
    AgenticXlsxUploadModal.width = 500;
    AgenticXlsxUploadModal.footer = null;
    AgenticXlsxUploadModal.onCancel = () => {
        AgenticXlsxUploadForm.form?.resetFields();
        AgenticXlsxUploadClose();
    };
    
    return (
        <Space>
            <Button type="primary" onClick={() => { AgenticXlsxUploadShow(); }}>
                {label}
            </Button>

            <Modal {...AgenticXlsxUploadModal}>
                <Form {...AgenticXlsxUploadForm} layout="vertical">
                    <Form.Item label="Upload XLSX">
                        <Space>
                            <Icons.UploadOutlined
                                onClick={handleIconClick}
                                style={{ cursor: 'pointer', fontSize: 20, opacity: 1 }}
                            />
                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                accept=".xlsx,.xls"
                                onChange={handleFileChange}
                            />
                        </Space>
                    </Form.Item>
                </Form>
            </Modal>
        </Space>
    );
};
